export default __webpack_public_path__ + "static/SR USA - Powder Caramel Color Lot Coding System - Statement-e129044e6aa58d620751bc26a21077c4.pdf";